;(function ( $ ) {

    /**
     *  chartThreeBars
     *  draws multiple bar-charts from tabular data
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'chartThreeBars';
    var defaults = {
        maxHeight: 280,
        animationDuration: 400,
        easing: 'easeInOutCubic', // 'easeOutElastic'
        barWidth: 90,
        barWidthMobile: 70,
        minValue: 20

    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {
            window.chartThreeBarsTimeout = [];
            if ($(window).width() <= 767) {
                this.displayMode = 'mobile';
            } else {
                this.displayMode = 'default';
            }
            this.data = this.parseDataTables();
            this.max = this.findMaxValue();
            this.heightRatio = this.settings.maxHeight / this.max;
            $(this.element).empty();
            if (this.data.length > 1) { // show Tabs
                this.renderTabs();
            }
            this.$graphWrapper = $('<div class="graph-wrapper" />');
            $(this.element).append(this.$graphWrapper);
            if (this.data.length <= 1) { // add padding to compensate missing tabs
                $(this.element).find('.graph-wrapper').css('margin-top', '50px');
            }

            this.renderGraph(0);
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(this.element).find('.graph-tabs').find('a').on('click', function(e) {
                e.preventDefault();
                if ($(this).hasClass('is-active')) return;
                $(this).parents('ul').find('.is-active').removeClass('is-active');
                $(this).addClass('is-active');
                _this.renderGraph($(this).data('index'));
            });
            $(this.element).find('.graph-tabs-wrapper').find('select').on('change', function() {
                _this.renderGraph($(this).val());
            });
            $(window).smartresize(function() {
                var lastMode = _this.displayMode;
                if ($(window).width() <= 767) {
                    _this.displayMode = 'mobile';
                } else {
                    _this.displayMode = 'default';
                }
                if (lastMode != _this.displayMode) {
                    $(_this.element).empty();
                    if (_this.data.length > 1) { // show Tabs
                        _this.renderTabs();
                    }
                    _this.$graphWrapper = $('<div class="graph-wrapper" />');
                    $(_this.element).append(_this.$graphWrapper);
                    if (_this.data.length <= 1) { // add padding to compensate missing tabs
                        $(_this.element).find('.graph-wrapper').css('margin-top', '50px');
                    }
                    if (_this.data.length > 1) {
                        if ($(_this.element).find('select').length) {
                            _this.renderGraph($(_this.element).find('select').val());
                        } else {
                            _this.renderGraph($(_this.element).find('a.is-active').data('index'));
                        }
                    } else {
                        _this.renderGraph(0);
                    }
                    // re-register tabs
                    $(_this.element).find('.graph-tabs').find('a').on('click', function(e) {
                        e.preventDefault();
                        if ($(this).hasClass('is-active')) return;
                        $(this).parents('ul').find('.is-active').removeClass('is-active');
                        $(this).addClass('is-active');
                        _this.renderGraph($(this).data('index'));
                    });
                    $(_this.element).find('.graph-tabs-wrapper').find('select').on('change', function() {
                        _this.renderGraph($(this).val());
                    });
                }
            });
        },

        parseDataTables: function() {
            var _this = this;
            var data = [];
            var dt;
            var keyVal;
            $(this.element).find('.graph-data-table').each(function(index, elem) {
                dt = {};
                dt.title = $(this).find('h3').text();
                dt.values = [];
                $(this).find('tr').each(function() {
                    keyVal = {
                        key: $(this).find('th').text(),
                        val: parseInt($(this).find('td').text()),
                        bgColorClass: $(this).data('bg-color-class'),
                        colorClass: $(this).data('color-class')
                    };
                    if ($(this).data('is-compound') === true) {
                       keyVal.isCompound = true;
                    }
                    if ($(this).data('parent')) {
                       keyVal.parentKey = $(this).data('parent');
                    }
                    dt.values.push(keyVal);
                });
                data.push(dt);
            });
            return data;
        },

        findMaxValue: function() {
            var max = this.settings.minValue;
            for (var i = 0; i < this.data.length; i++) {
                for (var j = 0; j < this.data[i].values.length; j++) {
                    if (this.data[i].values[j].val > max) {
                        max = this.data[i].values[j].val;
                    }
                }
            }
            return max;
        },

        renderGraph: function(index) {
            var _this = this;
            var data = _this.data[index];
            var $bar;
            var $barDivider;
            var $caption;
            var h;
            var z = 0;
            var compoundZ = 0;
            var bottomOffset = 120;
            var barWidth;
            var labelBottom = 0;
            var $legend;
            var hideDivider = true;
            if (this.displayMode == 'mobile') {
                barWidth = this.settings.barWidthMobile;
                // labelBottom = 40;
            } else {
                barWidth = this.settings.barWidth;
                // labelBottom = 0;
            }
            for (var i = 0; i < chartThreeBarsTimeout.length; i++) {
                window.clearTimeout(chartThreeBarsTimeout[i]);
            }
            var maxCompoundCaptionWidth = this.findMaxCompoundCaptionWidth(data);
            for (i = 0; i < data.values.length; i++) {
                if (!data.values[i].parentKey) { // standalone bar
                    bottomOffset = 120;
                    compoundZ = 0;
                    if ($(this.element).find('.bar-' + i).length) {
                        $bar = $(this.element).find('.bar-' + i);
                        $caption = $(this.element).find('.bar-caption-' + i);
                    } else {
                        $bar = $('<div class="bar-' + i + ' ' + data.values[i].bgColorClass + '" />');
                        $bar.css({
                            'width': barWidth + 'px',
                            'height': 2,
                            'position': 'absolute',
                            'bottom': bottomOffset + 'px',
                            'left': (barWidth + 20) * z + 'px'
                        });
                        $(this.element).find('.graph-wrapper').append($bar);
                        $caption = $('<div class="bar-caption bar-caption-' + i + ' ' + data.values[i].colorClass + '" />');
                        $caption.append('<span class="huge"><span class="huge-text">' + data.values[i].val +
                            '</span><br /><span class="huge-caption">'+ data.values[i].key +'</span></span>');
                        $caption.css({
                            'width': barWidth + 'px',
                            'position': 'absolute',
                            'bottom': labelBottom,
                            'left': (barWidth + 20) * z + 'px'
                        });
                        if (this.max > 999) {
                            $caption.find('.huge-text').css({
                                'font-size': '250%'
                            });
                        }
                        if (this.max > 9999) {
                            $caption.find('.huge-text').css({
                                'font-size': '180%'
                            });
                        }
                        $(this.element).find('.graph-wrapper').append($caption);
                        $(this.element).find('.bar-caption-' + i).hide().delay(400 * (i + 1)).fadeIn(800);
                    }
                    h = Math.round(data.values[i].val * this.heightRatio);
                    if (h < 2) h = 2;
                    $bar.animate({
                        'height': h
                    }, this.settings.animationDuration, this.settings.easing);
                    this.updateCaptionValue($caption, data.values[i].val);
                    z++;
                } else { // stacked bar
                    hideDivider = false;
                    if (this.displayMode == 'mobile') {
                        if ($(this.element).find('.legend').length) {
                            $legend = $(this.element).find('.legend');
                        } else {
                            $legend = $('<div class="legend color-bar-grey"></div>');
                            $(this.element).append($legend);
                            $legend = $(this.element).find('.legend');
                        }
                    } else {
                        $(this.element).find('.legend').remove();
                    }
                    var asterisks = '';
                    if (this.displayMode == 'mobile') {
                        for (var k = 1; k <= compoundZ + 1; k++) {
                            asterisks += '*';
                        }
                    }
                    var minH = 2;
                    if (bottomOffset > 120) {
                        minH = 0;
                    }
                    if ($(this.element).find('.bar-' + i).length) {
                        $bar = $(this.element).find('.bar-' + i);
                    } else {
                        if (this.displayMode == 'mobile') {
                            $legend.append('<span>' + asterisks + ' '  + data.values[i].key  + '</span>');
                        }
                        $bar = $('<div class="bar bar-' + i + ' ' + data.values[i].bgColorClass + '"><span class="value">' + asterisks + ' ' + data.values[i].val + '</span><span class="caption"></span></div>');
                        $(this.element).find('.graph-wrapper').append($bar);
                        $bar.css({
                            'width': barWidth + 'px',
                            'height': minH,
                            'position': 'absolute',
                            'bottom': '120px', // bottomOffset + 'px',
                            'left': (barWidth + 20) * (z - 1) + 'px'
                        });
                        if (i == 3) {
                            $bar.css('background-color', 'transparent');
                        }
                        if (this.displayMode == 'default') {
                            $bar.find('.caption').text(data.values[i].key).addClass(data.values[i].colorClass);
                            if (data.values[i].val) {
                                $bar.find('.caption').delay(this.settings.animationDuration * 2).fadeIn(200);
                            }
                        }
                    }

                    if (i == 3) {
                        if (data.values[2].val < data.values[3].val - 1) {
                            $bar.find('.value').css('color', $bar.find('.caption').css('color'));
                        } else {
                            $bar.find('.value').css('color', '#fff');
                        }
                    }
                    if (i == 4 ) {
                        if (data.values[4].val === 0) {
                            $bar.find('.value').css('color', $bar.find('.caption').css('color'));
                        } else {
                            $bar.find('.value').css('color', '#fff');
                        }

                    }
                    h = Math.round(data.values[i].val * this.heightRatio) - 5;
                    if (h < 25) {
                        h = 25;
                    }
                    if (h < minH) h = minH;
                    if (!data.values[i].val) {
                        h = minH;
                    }
                    $bar.find('.value').text(asterisks + ' ' + data.values[i].val).hide();
                    $bar.animate(
                        {
                            'height': h,
                            'bottom': bottomOffset
                        },
                        this.settings.animationDuration,
                        this.settings.easing
                        /* jshint ignore:start */
                        ,
                        function() {
                            $(this).find('.value').fadeIn(200);
                            if ($(this).find('.value').text()) {
                                $(this).find('.caption').hide().fadeIn(200);
                            }
                        }
                        /* jshint ignore:end */

                    );
                    bottomOffset += h + 10;
                    if (!compoundZ && data.values[i].val) { // draw divider
                        $bar.find('span.value').addClass('first');
                        $bar.find('span.caption').addClass('first');
                        if ($(this.element).find('.bar-divider-' + i).length) {
                            $barDivider = $(this.element).find('.bar-divider-' + i);
                        } else {
                            $barDivider = $('<div class="bar-divider bar-divider-' + i + ' ' + data.values[i].bgColorClass + '" />');
                            $(this.element).find('.graph-wrapper').append($barDivider);
                            $barDivider.css({
                                'width': '0',
                                'height': '10px',
                                'position': 'absolute',
                                'border-bottom': '4px solid #fff',
                                'border-top': '4px solid #fff',
                                'bottom': bottomOffset - 10 + 'px',
                                'left': (barWidth + 20) * (z - 1) + 'px'
                            });
                            $barDivider.delay(this.settings.animationDuration).animate({
                                'width': maxCompoundCaptionWidth + barWidth - 4
                            }, this.settings.animationDuration, _this.settings.easing);
                        }
                        $barDivider.animate({
                            'bottom': bottomOffset - 10 + 'px'
                        }, this.settings.animationDuration, _this.settings.easing);
                    }
                    compoundZ++;
                }
            }
            if (hideDivider) {
                $(this.element).find('.bar-divider').hide();
                $(this.element).find('.bar-4').hide();
                $(this.element).find('.value').hide();
                $(this.element).find('.caption').hide();
            } else {
                $(this.element).find('.bar-divider').show();
                $(this.element).find('.bar-4').show();
                $(this.element).find('.value').show();
                $(this.element).find('.caption').show();
            }
        },

        findMaxCompoundCaptionWidth: function(data) {
            var maxWidth = 0;
            if (this.mode == 'mobile') { // no stick out labels
                return maxWidth;
            }
            $(this.element).append('<div id="measure-bar" class="bar"><span class="caption"></span></div>');
            for (var i = 0; i < data.values.length; i++) {
                if (data.values[i].parentKey) {
                    $('#measure-bar').find('.caption').text(data.values[i].key);
                    if ($('#measure-bar').find('.caption').width() > maxWidth) {
                        maxWidth = $('#measure-bar').find('.caption').width();
                    }
                }
            }
            $('#measure-bar').remove();
            return maxWidth;
        },

        updateCaptionValue: function($elem, val) {
            var _this = this;
            var timeoutId;
            var currentVal = parseInt($elem.find('.huge-text').text());
            $elem.find('.huge-text').text(val);
            if (currentVal === val) return;
            if (currentVal > val) { // count down
                timeoutId = window.setTimeout(function() {
                    _this.countDown($elem, currentVal, val);
                }, 20);
            } else { // count up
                timeoutId = window.setTimeout(function() {
                    _this.countUp($elem, currentVal, val);
                }, 20);
            }
            chartThreeBarsTimeout.push(timeoutId);
        },

        countDown: function($elem, val, target) {
            var _this = this;
            if (val - target > 2000) {
                val = val - 999;
            } else {
                if (val - target > 200) {
                    val = val - 99;
                } else {
                    if (val - target > 20) {
                        val = val - 9;
                    } else {
                        if (val > target) {
                            val--;
                        } else {
                            return; // done
                        }
                    }
                }
            }
            $elem.find('.huge-text').text(val);
            var timeoutId = window.setTimeout(function() {
                _this.countDown($elem, val, target);
            }, 20);
            chartThreeBarsTimeout.push(timeoutId);
        },

        countUp: function($elem, val, target) {
            var _this = this;
            if (target - val > 2000) {
                val = val + 999;
            } else {
                if (target - val > 200) {
                    val = val + 99;
                } else {
                    if (target - val > 20) {
                        val = val + 9;
                    } else {
                        if (val < target) {
                            val++;
                        } else {
                            return; // done
                        }
                    }
                }
            }
            $elem.find('.huge-text').text(val);
            var timeoutId = window.setTimeout(function() {
                _this.countUp($elem, val, target);
            }, 20);
            chartThreeBarsTimeout.push(timeoutId);
        },

        renderTabs: function() {
            var $wrapper = $('<div class="graph-tabs-wrapper" />');

            var $li;
            var $tabs;
            var i;
            if ($(window).width() < 768) {
                $tabs = $('<select class="select2" />');
                for (i = 0; i < this.data.length; i++) {
                    $li = $('<option value="' + i + '">' + this.data[i].title + '</option>');
                    if (!i) {
                        $li.attr('selected', 'selected');
                    }
                    $tabs.append($li);
                }
            } else {
                $tabs = $('<ul class="graph-tabs is-clearfix" />');
                for (i = 0; i < this.data.length; i++) {
                    $li = $('<li><a href="#" class="color-event"></a></li>');
                    $li.find('a').text(this.data[i].title);
                    $li.find('a').data('index', i);
                    if (!i) {
                        $li.find('a').addClass('is-active');
                    }
                    $tabs.append($li);
                }
            }
            $wrapper.append($tabs);
            $(this.element).append($wrapper);
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
